/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  resetShareList,
  shareList,
  shareFile,
  shareFileRemove,
  listShareableAccounts,
  shareFileUpdateAccess,
} from 'store/slices/files';

export const useShareProperty = (propertyId, currentUser) => {
  const dispatch = useDispatch();

  /* shareable accounts */
  const users = useSelector((state) => state.files.shareableAccounts.value);
  const usersLoading = useSelector((state) => state.files.shareableAccounts.loading);
  /* shared users */
  const sharedUserList = useSelector((state) => state.files.shareList.value);

  useEffect(() => {
    if (!propertyId) return;

    dispatch(resetShareList());
    dispatch(shareList({ fileId: propertyId }));
  }, [propertyId]);

  /* shareable accounts without auth user and already shared user */
  const userList = useMemo(() => {
    return users.filter((user) => {
      const isAuthUser = user.id === currentUser?.id;
      const isAlreadyShared = sharedUserList.some((sharedUser) => sharedUser?.owner_account?.id === user.id);
      return !isAuthUser && !isAlreadyShared;
    });
  }, [users, currentUser, sharedUserList]);

  const handleRemoveShare = (id) => {
    if (!propertyId) return;
    dispatch(shareFileRemove({ fileId: propertyId, userId: id }))
      .unwrap()
      .then(() => dispatch(shareList({ fileId: propertyId })));
  };

  const handleShareAccessUpdate = (id, access) => {
    if (!propertyId) return;
    dispatch(shareFileUpdateAccess({ fileId: propertyId, userId: id, access }))
      .unwrap()
      .then(() => dispatch(shareList({ fileId: propertyId })));
  };

  const handleSearchUser = (query) => {
    return dispatch(listShareableAccounts({ query }))
      .unwrap()
      .then((data) => data);
  };

  const handleShareProperty = (user) => {
    if (!propertyId) return;
    dispatch(shareFile({ fileId: propertyId, userId: user.id, access: 'Read' }))
      .unwrap()
      .then(() => setTimeout(() => dispatch(shareList({ fileId: propertyId })), 1200));
  };

  return {
    userList,
    usersLoading,
    sharedUserList,
    handleSearchUser,
    handleShareProperty,
    handleUpdateShareProperty: (userId, action) =>
      action === 'Remove' ? handleRemoveShare(userId) : handleShareAccessUpdate(userId, action),
  };
};
